import React from 'react'

const ActionBarMapingGroupComp = (props) => {
    return (
        <>
            <div className="d-flex align-items-center py-1">
                {/*begin::Button*/}
                <a onClick={() => props.showFormAdd()} className="btn btn-sm btn-primary">Tambah Maping Group</a>
                {/*end::Button*/}
            </div>
        </>
    )
}

export default ActionBarMapingGroupComp
